import victor from '../../../img/victor.jpg';

export const useAboutMe = () => {
  return {
    avatarAlt: 'Victor Lima',
    avatarSrc: victor,
    title: 'Sobre Mim',
    paragraphs: [
      'Olá, me chamo Victor Lima, tenho 31 anos, sou formado em Análise e Desenvolvimento de Sistemas e Pós graduando em Desenvolvimento Full Stack Web e Cloud Computing.',
      'Sou Desenvolvedor Fullstack, onde lido com aplicações Web em React.js, Next.js, Node.js, MongoDB, MySQL, etc. Busco futuramente ingressar no mundo do desenvolvimento de aplicações nativas.',
      'Sou entusiasta de tecnologia, gosto de ler entre as linhas da indústria de tecnologia e tentar entender as motivações por trás de decisões que podem parecer incríveis, irracionais ou puramente simples.',
    ],
  };
};
